/**
 * AuditorBanner — subtle info bar shown to auditor-only users.
 * Indicates read-only access across the portal.
 */
import React from 'react';
import { makeStyles, tokens, Body2 } from '@fluentui/react-components';
import { EyeRegular } from '@fluentui/react-icons';
import { useIsAuditor } from '../../hooks/useIsAuditor';

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalL}`,
    backgroundColor: tokens.colorNeutralBackground4,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  icon: {
    color: tokens.colorNeutralForeground3,
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase200,
  },
});

export const AuditorBanner: React.FC = () => {
  const styles = useStyles();
  const { isAuditorOnly } = useIsAuditor();

  if (!isAuditorOnly) return null;

  return (
    <div className={styles.banner}>
      <span className={styles.icon}><EyeRegular /></span>
      <Body2 className={styles.text}>Auditor Mode — Read-only access</Body2>
    </div>
  );
};
